// extracted by mini-css-extract-plugin
export default {"form":"CommentsForm_form__RZSqK","invalid":"CommentsForm_invalid__jP2k9","actions":"CommentsForm_actions__BmBUM"};